import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import moment from "libs/moment";
import RingCountdown from "components/complex/countdown/RingCountdown";
import Workspace from "components/Workspace";
import Tr from "../../../translations/Translations";
import BoldTypography from "../../BoldTypography";
import DateFormats from "../../../constants/DateFormats";

function QuestionAnswerDeadlineSection(
    {
        endTimeCallback,
        currentRfxRound
    }) {


    const [durations, setDurations] = useState([]);


    useEffect(() => {
        if (!currentRfxRound) {
            return;
        }
        const end = moment(currentRfxRound.questionAnswerEndDate);
        const nowTime = moment(currentRfxRound.now);
        if (currentRfxRound.questionAnswerTimeEnded) {
            setDurations([0, 0]);
            return;
        }

        const duration2 = moment.duration(end.diff(nowTime));
        const number = duration2.asSeconds();

        const startTime = moment(currentRfxRound.offerStartDate);
        const startDuration = moment.duration(end.diff(startTime));
        const startNumber = startDuration.asSeconds();

        setDurations([number, startNumber]);
    }, [currentRfxRound]);

    const questionTimeEnded = durations.length > 0 && durations.every(x => x === 0);

    return (
        <Workspace
            render={
                <>
                    {!questionTimeEnded && <RingCountdown duration={durations[0]} baseDuration={durations[1]} endTimeCallback={endTimeCallback} title={Tr("left_to_question_answer_end_date")} width={100} fontSize={'2rem'}/>}
                    {questionTimeEnded  &&
                        <div>
                            <BoldTypography align='center'>{Tr('deadline_for_responding_to_asked_questions_expired')}</BoldTypography>
                            <BoldTypography align='center'>{currentRfxRound.questionAnswerEndDate ? moment(currentRfxRound.questionAnswerEndDate).format(DateFormats.DATE_FORMAT) : ''}</BoldTypography>
                        </div>
                    }
                </>}
        />
    )

}

QuestionAnswerDeadlineSection.propTypes = {
    demandStatistics: PropTypes.object,
    endTimeCallback: PropTypes.func,
}

QuestionAnswerDeadlineSection.defaultProps = {
    endTimeCallback: () => {
    },
}

export default QuestionAnswerDeadlineSection;